export default "__VITE_ASSET__DNDsk0lF__"